import "../styles/footer.css";
import {Link} from 'react-router-dom';

const Footer = () => {
  return (
    <div>
      <footer className="text-center text-white">
        <div className="container">
          <section className="mt-5">
            <div className="row justify-content-center pt-5">

            <div className="col-md-3 footerContent">
              <div className="footerLogo">
                <img src="/images/logo.png" alt="logo" />
              </div>
                <p className="font-weight-bold">
                  <a href="/contact" className="text-white text-decoration-none">
                    (5th Floor) Lal Ganga Business Park,<br/>Pachpedi Naka, Raipur (C.G.)<br/>
                    Pin Code: 492013
                  </a>
                </p>
              </div>

              <div className="col-md-2 footerContent">
                <h6 className="footerHeadtext">
                  <a href="/services" className="text-white">
                    Services
                  </a>
                </h6>
                <div className="footerItem">
                  <Link to="/service/application" className="text-white">
                    Application
                  </Link>
                  <Link to="/service/infrastructure" className="text-white">
                    Infrastructure
                  </Link>
                  <Link to="/service/cloud" className="text-white">
                    Cloud
                  </Link>
                  <Link to="/service/network" className="text-white">
                    Network
                  </Link>
                  <Link to="/service/security" className="text-white">
                      Security
                    </Link>
                </div>
              </div>

             
              <div className="col-sm-2 footerContent">
              <h6 className="footerHeadtext">
                  <a href="#!" className="text-white">
                    More
                  </a>
                </h6>
                <div className="footerItem">
                  <Link to="/service/datacenter" className="text-white">
                    Data Center
                  </Link>
                    <Link to="/service/virtualization" className="text-white">
                      Virtualization
                    </Link>
                    <Link to="/service/consulting" className="text-white">
                     IT Consulting
                    </Link>
                </div>
                  </div>

                  <div className="col-md-2 footerContent">
                  <h6 className="footerHeadtext">
                  <a href="#!" className="text-white">
                    Learn More
                  </a>
                </h6>
                <div className="footerItem">
                  <Link to="/about" className="text-white">
                    About Company
                  </Link>
                  <Link to="/casestudy" className="text-white">
                    Case Studies
                  </Link>
                  <Link to="/contact" className="text-white">
                    Contact
                  </Link>
                </div>
              </div>
             

              <div className="col-md-2 footerContent">
                <h6 className="footerHeadtext">
                  <a href="/contact" className="text-white">
                    Contact Us
                  </a>
                </h6>
                <div className="footerItem">
                  <a href="/contact" className="text-white">
                    Call Us: (+91)-7999108880
                  </a>
                  <a href="/contact" className="text-white">
                    Toll Free No : 7713554780
                  </a>
                  <a href="/contact" className="text-white">
                    Email: info@jrglobalservices.com
                  </a>
                  </div>
              </div>
            </div>
          </section>

          <hr className="my-5" />

      

          <section className="text-center mb-5">
            <a href="https://www.facebook.com/" className="text-white me-4">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.twitter.com/" className="text-white me-4">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://www.google.com/" className="text-white me-4">
              <i className="fab fa-google"></i>
            </a>
            <a href="https://www.instagram.com/" className="text-white me-4">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/" className="text-white me-4">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://www.github.com/" className="text-white me-4">
              <i className="fab fa-github"></i>
            </a>
          </section>
        </div>

        <div className="text-center p-3">
          © 2020 Copyright:
          <a className="text-white" href="www.jrglobalservices.com">
            JR Global Consultancy And Services
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
